import { defineStore } from 'pinia';
import { useHttp } from '@/http/http';
import { statusCheck } from '../public';
import Swal from 'sweetalert2';


export const useSettingsStore = defineStore('settings', {
  state: () => ({
    settings: '',
  }),
  actions: {

    async fetchSettings() {
      const url = `/api/admin/setting/list`;
      try {
        const response = await useHttp().get(url);
        this.settings = response.data.settings;
      } catch (error) {
        console.error('Error fetching settings:', error);
        throw error;
      }
    },
    async updateSettings(payload) {
      try {
        const response = await useHttp().post('/api/admin/setting/update', payload);
        if(statusCheck(response.data)){
          Swal.fire({
            icon: 'success',
            title: response.data.message ,
            showConfirmButton: false,
            timer: 1500
          });
        await this.fetchSettings();  // 更新後重新加載成員列表
      }
      } catch (error) {
        console.error('Error updating settings:', error);
        throw error;
      }
    },
  },
});
